import React, { useState } from 'react';
import WeeklySlotManager from './WeeklySlotManager';
import DateSlotManager from './DateSlotManager';
import AppointmentsList from './AppointmentsList';
import { Calendar, Clock, Users } from 'lucide-react';

const AppointmentManager: React.FC = () => {
  const [viewMode, setViewMode] = useState<'weekly' | 'calendar' | 'appointments'>('appointments');

  return (
    <div className="p-6">
      {/* Sélecteur de mode */}
      <div className="flex items-center justify-center space-x-4 mb-6">
        <button
          onClick={() => setViewMode('weekly')}
          className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium transition-colors ${
            viewMode === 'weekly'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <Clock className="w-5 h-5" />
          <span>Configuration Hebdomadaire</span>
        </button>
        
        <button
          onClick={() => setViewMode('calendar')}
          className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium transition-colors ${
            viewMode === 'calendar'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <Calendar className="w-5 h-5" />
          <span>Gestion par Date</span>
        </button>
        
        <button
          onClick={() => setViewMode('appointments')}
          className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium transition-colors ${
            viewMode === 'appointments'
              ? 'bg-green-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <Users className="w-5 h-5" />
          <span>Rendez-vous pris</span>
        </button>
      </div>

      {/* Contenu selon le mode */}
      {viewMode === 'weekly' ? (
        <WeeklySlotManager onClose={() => {}} />
      ) : viewMode === 'calendar' ? (
        <DateSlotManager />
      ) : (
        <AppointmentsList />
      )}
    </div>
  );
};

export default AppointmentManager;
